// extracted by mini-css-extract-plugin
export var bg = "style-module--bg--32aa2";
export var edu = "style-module--edu--9eed4";
export var text = "style-module--text--64c9a";
export var vid = "style-module--vid--299f7";
export var wrap = "style-module--wrap--4c512";